import styled from "styled-components";

export const StyledFooter = styled.div`
    position: relative;

    .shadow{
        position: absolute;
        width: 100%;
        height: 100%;
        background: #121212;
        opacity: 0.8;
    }

    .footer-main{
        position: relative;
        z-index: 2;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 40px 0;
        color: white;

        .footer-logo{
            svg:hover{
                cursor: pointer;
                path{
                    fill:#BB0600;
                }
            }
            p{
                font-size: 20px;
                line-height: 35px;
                width: 55%;
                margin-top: 36px;
            }

            .social{
                display: flex;
                align-items: center;
                gap: 28px;
                margin-top: 20px;
                margin-bottom: 30px;

                svg:hover{
                    path{
                        fill: #2B87D0;
                    }
                }
            }
        }

        .footer-info{
            display: flex;
            align-items: flex-start;
            gap: 100px;

            h3{
                font-weight: 600;
                font-size: 24px;
                line-height: 33px;
            }
            .footer-items{
                .footer-item{
                    &:hover{
                    color: #BB0600;
                }
                }
            }
            .footer-item{
                list-style: none;
                margin-top: 15px;
                display: flex;
                gap:16px;
                transition: all 0.4s ease-out;
                font-size: 18px;
                line-height: 25px;
                cursor: pointer;
            
               

                &:hover{
                        svg{
                            /* fill: #2B87D0; */
                            path{
                                fill:#2B87D0;
                            }
                        }
                    }

                

                p{
                    a{
                        color:#2B87D0;
                    }
                    span{
                        font-size: 18px;
                        line-height: 25px;
                    }
                   
                }
            }
        }

        @media (max-width:1200px) {
            .footer-info{
                gap: 50px;
            }
        }
        @media (max-width: 992px) {
            flex-direction: column-reverse;
            align-items: flex-start;
            position: relative;

            .footer-info{
                flex-wrap: wrap;
                margin-top: 60px;
            }
            .footer-logo{
                .logo{
                    position: absolute;
                    top: 30px;
                    left:0;
                }
            }
        }
    }




`